import { useNavigate } from 'react-router-dom';
import { PermissionsEnum } from '@/auth/interfaces';
import { EstadoFactibilidadCorporativaENUM, ROUTER_PATHS } from '@/shared';
import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
import { TABLE_CONSTANTS } from '@/shared/constants/ui';
import {
  useCheckPermissions,
  useTableColumnsFactibilidadCorporativa,
  useTableServerSideFiltering,
} from '@/shared/hooks';
import { useTableFilter } from '@/shared/hooks/useTableFilter';

import { hasPermission } from '@/shared/utils';
import { Grid, IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useFetchGetfactibilidadCorporativos } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';
import InfoCoordendas from '@/shared/components/ui/InfoCoordendas/InfoCoordendas';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';
import { useState } from 'react';

export type PreagendamientoPendientePageEstadoAceptacionProps = {
  estado_aceptacion?: boolean;
  // reversosCero?: boolean;
};


const PreagendamientoPendientePageEstadoAceptacion: React.FC<
  PreagendamientoPendientePageEstadoAceptacionProps
> = () => {

  //PERMISSIONS
  useCheckPermissions(PermissionsEnum.api_view_agendacorporativa);

  const navigate = useNavigate();
  const [rowSelection, setRowSelection]=useState({})
  //GLOBALS
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();


  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: PreagendamientosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchGetfactibilidadCorporativos({
    page: pageIndex + 1,
    page_size: pageSize,
    identificacion: searchTerm,
    ...filterObject,
    filterByState: false,
    estado_factibilidad: `${EstadoFactibilidadCorporativaENUM.APROBADO}`,
    revisado_supervisor:true,
    factibilidad_enviada: true,
  })

  ///* handlers
  const onEdit = async (factibilidadCoorp: IFactibilidadCorporativo) => {

    navigate(
      `${ROUTER_PATHS.noc.createAgendamientoNocNav}/${factibilidadCoorp.id_factibilidad_coorporativa}`
    );

  }

  ///* columns

  const { columnsFactibilidad } = useTableColumnsFactibilidadCorporativa();


  return (
    <>
      <TableTabsScene
        globalFilter={globalFilter}
        onChangeFilter={onChangeFilter}
      >
        <GeneralTable<IFactibilidadCorporativo>
          columns={columnsFactibilidad}
          data={PreagendamientosPagingRes?.data?.data || []}
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // // search
          enableGlobalFilter={false}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={PreagendamientosPagingRes?.data?.count}
          // // actions ========
          enableColumnActions={hasPermission(
            PermissionsEnum.api_change_factibilidadcoorporativa
          )}
          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
          // crud
          //
          enableSelectAll
          enableRowSelection
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          pinLeftColumnIndexes={[0,1,2]}
          /* canEdit={hasPermission(PermissionsEnum.api_change_preagendamiento)}
          onEdit={onEdit}
          canDelete={false} */
          canEdit={false}
          canDelete={false}
          enableEditing={true}
          showCustomActionBtnSpace={true}
          customActionBtnSpace={(value) => {
            return (
              <Grid container>
                <Grid item>
                  <IconButton
                    onClick={() => onEdit(value)}
                  >
                    <Edit />
                  </IconButton>

                </Grid>
              </Grid>
            )
          }}

        />
      </TableTabsScene>

      <InfoCoordendas />
    </>
  );
};

export default PreagendamientoPendientePageEstadoAceptacion;
